module.exports = __webpack_public_path__ + "img/taxi_night_up_selected.09ed96e8.svg";